// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderBundleInfoBar_link__2tPMh","dvgText":"HeaderBundleInfoBar_dvgText__2Lt7p","bundleInfo":"HeaderBundleInfoBar_bundleInfo__1tua2"};